export function addCurrent(reason) {
    return {
        type: 'ADD_CURRENT',
        reason,
    }
}
